var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15962 6.62051V3.43846C8.15948 3.29896 8.12265 3.16194 8.05284 3.04116C7.98303 2.92039 7.88268 2.82009 7.76187 2.75034L4.97757 1.15931C4.85663 1.08949 4.71945 1.05273 4.57981 1.05273C4.44017 1.05273 4.30299 1.08949 4.18205 1.15931L1.39776 2.75034C1.27694 2.82009 1.1766 2.92039 1.10678 3.04116C1.03697 3.16194 1.00014 3.29896 1 3.43846V6.62051C1.00014 6.76002 1.03697 6.89703 1.10678 7.01781C1.1766 7.13859 1.27694 7.23888 1.39776 7.30863L4.18205 8.89966C4.30299 8.96948 4.44017 9.00624 4.57981 9.00624C4.71945 9.00624 4.85663 8.96948 4.97757 8.89966L7.76187 7.30863C7.88268 7.23888 7.98303 7.13859 8.05284 7.01781C8.12265 6.89703 8.15948 6.76002 8.15962 6.62051Z",
    stroke: "#DAD873",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10742 3.0249L4.57984 5.03357L8.05225 3.0249",
    stroke: "#DAD873",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58008 9.03893V5.02954",
    stroke: "#DAD873",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsBox);
export default __webpack_public_path__ + "static/media/statistics-box.0acb66b2a2eb74cee44184e6f62eb36f.svg";
export { ForwardRef as ReactComponent };